<template>
  <div v-loading="loading" class="mainItem">
    <div v-if="queryInfo.title" class="result-title">
      <span>关于</span><span class="active">"{{ queryInfo.title }}"</span>共搜索到以下 {{ numQuestion }} 个相关问题
    </div>
    <div v-if="queryList.length > 0" class="context-right-detail">
      <div v-for="(item,index) in queryList" :id="'id'+index" :key="index" class="context-item">
        <div v-if="item.page.list && item.page.list.length>0||!queryInfo.title" class="context-item_borde">
          <p class="title">
            {{ item.classifyName }}
          </p>
          <div :class="[queryInfo.title?'detail-box2':'detail-box']">
            <div v-for="(v,i) in item.page.list" :key="i" class="item nowrap" :title="v.title" @click="jumpPage(v)">
              {{ v.title }}
            </div>
          </div>
          <div v-if="pageNum[item.id]*queryInfo.pageSize < item.page.total" class="more" @click="LoadMore(item.id)">
            <p class="more-text">
              <img src="@/assets/img/arrow.png" class="moreImg" alt>
            </p>
          </div>
        </div>
      </div>
    </div>
    <global-empty
      v-else
      :label="`暂无数据~`"
      height="200"
      link-it="3"
    />
  </div>
</template>
<script>
import { getQueryList } from '@/api/helpCenter';
export default {
  props: {
    searchKey: {
      type: String,
      default: () => ''
    },
    classifysInfo: {
      type: Array,
      default: () => []
    },
    selectIndex: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      flag: 1,
      loading: false,
      numQuestion: 0,
      queryList: [],
      pageSize: 15,
      pageNum: {},
      queryInfo: {
        classifyId: '',
        title: '',
        pageSize: 15,
        pageNum: 1
      }
    };
  },
  watch: {
    selectIndex: {
      handler: function() {
        this.getHelpClassifys();
      },
      immediate: true
    }
  },
  mounted() {
    this.classifysInfo.forEach((v) => { this.$set(this.pageNum, v.id, 1); });
    this.init();
  },
  methods: {
    init() {
      this.$EventBus.$on('queryEvent', (params) => {
        this.queryInfo.title = params;
        this.queryInfo.pageNum = 1;
        this.queryList = [];
        this.numQuestion = 0;
        this.getQueryList();
      });
      this.queryInfo.title = this.searchKey;
      this.getQueryList();
    },

    getHelpClassifys() {
      this.$nextTick(() => {
        this.classifysInfo.forEach((v, i) => {
          if (this.selectIndex === v.id) {
            var items = document.querySelectorAll('.context-item');
            items[i] && items[i].scrollIntoView({
              block: 'center', // 默认跳转到中部
              behavior: 'smooth' // 滚动的速度
            });
          }
        });
      });
    },
    jumpPage(v) {
      this.$EventBus.$emit('putbackMenu');
      this.$router.push({ name: 'mainDetail', query: { id: v.id, keyword: this.searchKey }});
    },
    async getQueryList() {
      this.loading = true;
      await getQueryList(this.queryInfo).then(res => {
        const data = res.data;
        this.numQuestion = 0;
        this.queryList = data;
        this.loading = false;
        this.queryList.forEach((v) => {
          this.numQuestion += v.page.total;
        });
      }).catch(() => { this.loading = false; });
      this.getHelpClassifys();
    },
    async getQueryList2(classifyId) {
      this.loading = true;
      await getQueryList(this.queryInfo).then(res => {
        const data = res.data;
        this.queryList.forEach((v) => {
          if (v.id === classifyId) {
            v.page.list = v.page.list.concat(data[0].page.list);
          }
        });
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    LoadMore(key) {
      this.queryInfo = {
        classifyId: key,
        title: this.queryInfo.title,
        pageSize: 15,
        pageNum: ++this.pageNum[key]
      };
      this.flag = 0;
      this.getQueryList2(key);
    }
  }
};
</script>
<style lang="scss" scoped>
.mainItem{
  // width: calc(100% - 440px);
  border: 1px solid #ECECEC;
  padding: 17px 20px;
  margin-left: 210px;
  .result-title{
        font-size: 16px;
        font-weight: 400;
        color: #555555;
        padding-bottom: 20px;
        .active{
            color: #007AFC;
            font-weight: Bold;
        }
    }
    .context-right-detail{
        font-family: Microsoft YaHei;
        .context-item{

            margin-bottom: 30px;
            .context-item_borde{
            border-bottom: 1px dashed #ECECEC;
            &:last-child{
                  border-bottom: 0;
              }
            }
            .title{
                font-size: 16px;
                font-weight: bold;
                color: #555555;
            }
            .detail-box{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
                font-size: 14px;
                font-weight: 400;
                color: #0089C9;
                text-align: center;
                .item{
                    width: calc((100% - 10px) / 3);
                    padding: 15px 0 15px 15px;
                    text-align: left;
                    &:hover{
                        color: #0089C9;
                        font-weight:Bold;
                        cursor: pointer;
                    }
                }
            }
            .detail-box2{
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
                font-size: 14px;
                font-weight: 400;
                color: #0089C9;
                text-align: center;
                .item{
                    width: calc((100% - 10px) / 2);
                    padding: 15px 0 15px 15px;
                    text-align: left;
                    &:hover{
                        color: #0089C9;
                        font-weight:Bold;
                        cursor: pointer;
                    }
                }
            }
            .more{
                margin: 30px 43%;
                text-align: center;
                font-size: 12px;
                font-weight: 400;
                .more-text{
                    padding: 5px 0;
                    cursor: pointer;
                }
                .moreImg {
                  height: 12px;
                  width: 12px;
                }
                .no-more-infor{
                  color: #CACACA;
                }
            }
        }
    }
}

</style>
